// extracted by mini-css-extract-plugin
export default {"wrapper":"ModalAddEnvironment_wrapper__8r2N4","head":"ModalAddEnvironment_head__jvER-","content":"ModalAddEnvironment_content__H-FTz"};